import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FileCaptureService } from 'app/service/file-capture.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileServiceService } from '../service/file-service.service';

@Component({
  standalone: false,
  selector: 'app-initiate-download',
  templateUrl: './initiate-download.component.html',
  styleUrls: ['./initiate-download.component.css']
})
export class InitiateDownloadComponent implements OnInit {
  error: boolean = false;
  @Input()
  showCaptcha: boolean | undefined;  
  captcha: string;

  constructor(
    private route: Router, 
    public service: FileServiceService,  
    private fcservice : FileCaptureService,
    private ngxspinner : NgxSpinnerService
    ) {
      this.captcha = '';
    }


  ngOnInit(): void {
            
    this.service.setPageVisited('initiate-download');
    if (this.service.getCache('files')) {
      this.service.referenceFileDetails.files = this.service.getCache('files');
    }
    if (this.service.getCache('caseActivityKey')) {
      this.service.referenceFileDetails.caseActivityKey = this.service.getCache('caseActivityKey');
    }
    if (this.service.getCache('contactName')) {
      this.service.referenceFileDetails.contactName = this.service.getCache('contactName');
    }
    if (this.service.getCache('contactPhone')) {
      this.service.referenceFileDetails.contactPhone = this.service.getCache('contactPhone');
    }
    if (this.service.getCache('contactEmail')) {
      this.service.referenceFileDetails.contactEmail = this.service.getCache('contactEmail');
    }
    if (this.service.getCache('referenceId')) {
      this.service.referenceFileDetails.referenceId = this.service.getCache('referenceId');
    }
    if (this.service.getCache('businessName')) {
      this.service.referenceFileDetails.businessName = this.service.getCache('businessName');
    }
  } 

  next() {
    this.ngxspinner.show()
    const distinctServerCaseActivityKeys = Array.from(new Set(
      this.service.referenceFileDetails.files
        .map((file: any) => file.serverCaseActivityKey || file.caseActivityKey)
        .filter((caseActivityKey: any) => !!caseActivityKey)
    ));
    const shouldOmitCaseActivityKey = distinctServerCaseActivityKeys.length > 1;

    let data = {
      BusinessName : this.service.referenceFileDetails.businessName,
      ContactName : this.service.referenceFileDetails.contactName,
      ContactPhone : this.service.referenceFileDetails.contactPhone,
      ContactEmail : this.service.referenceFileDetails.contactEmail,
      ReferenceId : this.service.referenceFileDetails.referenceId,
      CaseActivityKey : shouldOmitCaseActivityKey ? undefined : this.service.referenceFileDetails.caseActivityKey,
      ActiveAttachmentKey: this.service.referenceFileDetails.files.map((x: any) => x.attachmentKey),
      TimeZoneUtcDifference: new Date().getTimezoneOffset()

    };

    console.log('[InitiateDownload][submitDocument] payload', {
      referenceId: data.ReferenceId,
      caseActivityKey: data.CaseActivityKey,
      shouldOmitCaseActivityKey,
      distinctServerCaseActivityKeys,
      activeAttachmentKeys: data.ActiveAttachmentKey,
      activeAttachmentKeysJson: JSON.stringify(data.ActiveAttachmentKey),
      files: this.service.referenceFileDetails.files.map((file: any) => ({
        fileName: file.fileName,
        attachmentKey: file.attachmentKey,
        caseActivityKey: file.caseActivityKey,
        serverCaseActivityKey: file.serverCaseActivityKey,
        scanStatus: file.scanStatus
      })),
      filesJson: JSON.stringify(this.service.referenceFileDetails.files.map((file: any) => ({
        fileName: file.fileName,
        attachmentKey: file.attachmentKey,
        caseActivityKey: file.caseActivityKey,
        serverCaseActivityKey: file.serverCaseActivityKey,
        scanStatus: file.scanStatus
      })))
    });
  
    this.fcservice.submitDocument(data).subscribe((res) => {
      this.ngxspinner.hide()
      if(res){
        const sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';
        const payorKey = Number(window.sessionStorage.getItem(this.fcservice.PAYOR_KEY) || 0);
        this.fcservice.releaseActiveReferenceLock(payorKey, data.ReferenceId, sessionId).subscribe();
        this.route.navigate(['confirmation']); 
      }
      else{
        this.ngxspinner.hide();
        this.error = true;
      }
    }, error => {this.ngxspinner.hide()});
  }

  back() {
    this.route.navigate(['review-files']);
  }
  captchaEvent(captcha: string) {
    this.captcha = captcha;
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
}

}